/* Progressive enhancement for Judge.me's dynamically inserted review cards. */
(function () {
  'use strict';
  var cardSelector = '.jdgm-popup-widget .jdgm-popup-card';
  var closeSelector = '.jdgm-popup-card__close-btn';
  var linkSelector = '.jdgm-popup-card__full-rev-link';
  var observed = new WeakSet();
  var lastOutside = null;
  var focusedCard = null;
  var keyboard = false;
  var scheduled = false;

  function visible(element) {
    var style = window.getComputedStyle(element);
    return element.isConnected && element.getClientRects().length > 0 &&
      style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
  }

  function restoreFocus() {
    focusedCard = null;
    if (lastOutside && visible(lastOutside)) {
      lastOutside.focus({ preventScroll: true });
      return;
    }
    var main = document.querySelector('main');
    if (main) {
      var original = main.getAttribute('tabindex');
      main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
      if (original === null) main.removeAttribute('tabindex');
      else main.setAttribute('tabindex', original);
    }
  }

  function overlaps(first, second) {
    return first.left < second.right && first.right > second.left &&
      first.top < second.bottom && first.bottom > second.top;
  }

  function update() {
    scheduled = false;
    if (focusedCard && !visible(focusedCard)) restoreFocus();
    document.querySelectorAll(cardSelector).forEach(function (card) {
      var close = card.querySelector(closeSelector);
      var link = card.querySelector(linkSelector);
      var shown = visible(card);
      if (close) close.setAttribute('tabindex', shown ? '0' : '-1');
      if (link) {
        var product = card.querySelector('.jdgm-popup-card__prod-title');
        var title = product ? product.textContent.trim() : '';
        link.setAttribute('aria-label', title ? 'Read review of ' + title : 'Read full customer review');
        link.setAttribute('tabindex', shown ? '0' : '-1');
      }
      var active = document.activeElement;
      if (shown && close && keyboard && active && active !== document.body &&
          !active.closest('.jdgm-popup-widget') &&
          overlaps(card.getBoundingClientRect(), active.getBoundingClientRect())) {
        // Let Judge.me dismiss its widget; do not change app settings or content.
        close.click();
      }
    });
  }

  function schedule() {
    if (!scheduled) {
      scheduled = true;
      window.requestAnimationFrame(update);
    }
  }

  function discover() {
    document.querySelectorAll('.jdgm-popup-widget').forEach(function (widget) {
      if (observed.has(widget)) return;
      observed.add(widget);
      new MutationObserver(schedule).observe(widget, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']
      });
    });
    schedule();
  }

  document.addEventListener('pointerdown', function () { keyboard = false; }, true);
  document.addEventListener('focusin', function (event) {
    focusedCard = event.target.closest(cardSelector);
    if (!event.target.closest('.jdgm-popup-widget')) lastOutside = event.target;
    schedule();
  });
  document.addEventListener('keydown', function (event) {
    keyboard = true;
    var card = event.target.closest(cardSelector);
    if (!card) return;
    var close = event.target.closest(closeSelector);
    var link = event.target.closest(linkSelector);
    if (event.key === 'Escape') {
      event.preventDefault();
      var dismiss = card.querySelector(closeSelector);
      if (dismiss) dismiss.click();
    } else if ((close && (event.key === 'Enter' || event.key === ' ')) ||
               (link && event.key === ' ')) {
      event.preventDefault();
      if (!event.repeat) event.target.click();
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest(closeSelector) && focusedCard) restoreFocus();
  }, true);
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  new MutationObserver(discover).observe(document.body, { childList: true, subtree: true });
  discover();
}());
